<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style>

    .osfQuizEndPage {
        font-family: Roboto;
        align-items: center;
        justify-content: center;
        min-height: 25rem;
    }

    .osfQuizEndPage h2, .osfQuzizEndPage p {
        font-family: Roboto-Medium;
    }

    .osfQuizEndPage h2 {
        font-size: 1.5rem;
        color: #333333;
        text-align: center;
    }

    .osfQuizEndPage p {
        font-size: 0.875rem;
        text-align: center;
    }
</style>

<template>
    <div
        class="osfQuizEndPage"
        v-html="endHtml"
    />
</template>

<script>
export default {
    name: 'ThankYou',
    computed: {
        endHtml: function () {
            return this.$store.state.endHTML;
        }
    }
};
</script>
